/* eslint-disable camelcase */
import { emptyObject, undefinedCheck } from '@sitecore-search/common';
import RFKApiAdapter from '../api/apiAdapter.js';
import { getUserId } from '../api/siteInfo.js';
/**
 * Event's data: https://doc.sitecore.com/search/en/developers/search-developer-guide/tracking-events.html
 */
export const track = async (params) => {
    // TODO [Events] flag. Disable or enable event tracking
    return await RFKApiAdapter.trackEvent({
        ...params,
        uuid: getUserId().uuid,
        client_time_ms: Date.now(),
    });
};
export const validateEntities = (entities) => {
    return !entities.find(({ id, entity_type }) => undefinedCheck(id) || undefinedCheck(entity_type));
};
export const validateFilters = (filters) => {
    return !filters.find(({ facetId }) => undefinedCheck(facetId));
};
export const validateCategory = (clickTextId, clickText, clickUri) => !undefinedCheck(clickTextId) && !undefinedCheck(clickText) && !undefinedCheck(clickUri);
export const validateTransaction = (orderId) => !undefinedCheck(orderId);
export const validateReview = (id) => !undefinedCheck(id);
export const buildEventEntities = (entity, items) => items.map(({ id, entitySubtype, attributes, variant, uri, sourceId }) => ({
    id,
    entity_type: entity,
    ...(entitySubtype ? { entity_subtype: entitySubtype } : {}),
    ...(attributes && !emptyObject(attributes) ? { attributes } : {}),
    ...(variant ? { variant } : {}),
    ...(uri ? { uri } : {}),
    ...(sourceId ? { source_id: sourceId } : {}),
}));
export const buildTransactionObject = (orderId, orderTotal, orderSubtotal, coupon) => {
    return {
        order_id: orderId,
        ...(orderTotal ? { order_total: orderTotal } : {}),
        ...(orderSubtotal ? { order_subtotal: orderSubtotal } : {}),
        ...(coupon ? { coupon } : {}),
    };
};
export const buildReviewObject = (id, rating, comment) => {
    return {
        id,
        ...(rating ? { rating } : {}),
        ...(comment ? { comment } : {}),
    };
};
export const buildRequestObject = ({ keyword, advancedQueryText, modifiedKeyword, numResults, totalResults, numRequested, pageSize, pageNumber, redirectUrl, }) => {
    return {
        ...(keyword ? { keyword } : { keyword: '' }),
        ...(advancedQueryText ? { advanced_query_text: advancedQueryText } : {}),
        ...(modifiedKeyword ? { modified_keyword: modifiedKeyword } : {}),
        ...(numResults ? { num_results: numResults } : {}),
        ...(totalResults ? { total_results: totalResults } : {}),
        ...(numRequested ? { num_requested: numRequested } : {}),
        ...(pageSize ? { page_size: pageSize } : {}),
        ...(pageNumber ? { page_number: pageNumber } : {}),
        ...(redirectUrl ? { redirect_url: redirectUrl } : {}),
    };
};
export const facetSchemaFormatter = (filters) => filters.map(({ facetId, facetValue, startValue, endValue, facetValueId, valueIndex, facetIndex, facetTitle }) => ({
    name: facetId,
    title: facetTitle,
    ...(facetId ? { field: facetId } : {}),
    ...(facetValueId ? { value: [facetValueId] } : facetValue ? { value: [facetValue] } : {}),
    ...(startValue ? { start_value: startValue } : {}),
    ...(endValue ? { end_value: endValue } : {}),
    ...(facetValue ? { display_name: [facetValue] } : {}),
    ...(valueIndex || valueIndex === 0 ? { value_position: [valueIndex] } : {}),
    ...(facetIndex || facetIndex === 0 ? { facet_position: facetIndex } : {}),
}));
export const filterSchemaFormatter = (filters) => filters.map(({ name, title, value, displayName, uri }) => ({
    name,
    title,
    ...(value ? { value: [value] } : {}),
    ...(displayName ? { display_name: [displayName] } : {}),
    ...(uri ? { uri: [uri] } : {}),
}));
export function cleanJSONSchema(obj) {
    const cleanedObj = {};
    for (const key in obj) {
        const value = obj[key];
        if (value !== undefined &&
            value !== null &&
            !(typeof value === 'object' && Object.keys(value).length === 0 && !Array.isArray(value)) &&
            !(typeof value === 'undefined')) {
            if (Array.isArray(value)) {
                const cleanedArray = [];
                for (let i = 0; i < value.length; i++) {
                    const item = value[i];
                    if (item !== null &&
                        item !== undefined &&
                        !(typeof item === 'object' && Object.keys(item).length === 0 && !Array.isArray(item))) {
                        if (typeof item === 'object') {
                            const cleanedValue = cleanJSONSchema(item);
                            if (Object.keys(cleanedValue).length > 0 || Array.isArray(cleanedValue)) {
                                cleanedArray.push(cleanedValue);
                            }
                        }
                        else {
                            cleanedArray.push(item);
                        }
                    }
                }
                if (cleanedArray.length > 0) {
                    cleanedObj[key] = cleanedArray;
                }
            }
            else if (typeof value === 'object' && Object.keys(value).length > 0) {
                const cleanedValue = cleanJSONSchema(value);
                if (Object.keys(cleanedValue).length > 0 || Array.isArray(cleanedValue)) {
                    cleanedObj[key] = cleanedValue;
                }
            }
            else {
                cleanedObj[key] = value;
            }
        }
    }
    return cleanedObj;
}
